import { LOGOUT_SUCCESS } from '../actions/logout';
import api from '../api';

const DISCHARGE_PROGRESS_LIST_SUCCESS =
  api.events.dischargeProgressList.actionSuccess;
const DISCHARGE_PROGRESS_CREATE_SUCCESS =
  api.events.dischargeProgressCreate.actionSuccess;

const defaultState = { all: [] };

export default function(state = defaultState, action) {
  switch (action.type) {
    case DISCHARGE_PROGRESS_CREATE_SUCCESS: {
      return {
        all: [action.data, ...state.all]
      };
    }

    case DISCHARGE_PROGRESS_LIST_SUCCESS:
      return { all: action.data };

    case LOGOUT_SUCCESS:
      return defaultState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dischargeProgress.js